<template>
  <div style="padding: 0 15px;" v-if="storeList.length">
    <el-radio-group v-model="activeName" @change="handleRadioChange">
      <!-- <swiper class="swiper" :options="swiperOption">
        <swiper-slide v-for="(item, index) in storeList" :key="index"> -->
          <el-link type="primary" :underline="false" @click="collapse = !collapse;" style="margin:10px 10px 0 0; float: right;" v-if="storeList.length > 7">{{collapse?'收起':'更多店铺'}}</el-link>
          <el-radio :label="item.shopName" v-for="item in collapseNStore" :key="item.shopName" border size="small">
            <span>{{item.shopName}}</span>
            <!-- <span class="iconfont" :class="`icon-dengji-${item.shopGrade}`" v-if="item.shopGrade"></span> -->
          </el-radio>
          <template v-if="collapse">
            <el-radio :label="item.shopName" v-for="item in collapseYStore" :key="item.shopName" border size="small">
              <span>{{item.shopName}}</span>
            </el-radio>
          </template>
        <!-- </swiper-slide>
      </swiper> -->
    </el-radio-group>
  </div>
</template>

<script>
export default {
  props: ['form'],
  data() {
    return {
      storeList: [],
      activeName: '全平台',
      swiperOption: {
        slidesPerView: parseInt((document.documentElement.clientWidth - 180) / 135),
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      collapse: false,
      collapseNStore: [],
      collapseYStore: []
    }
  },
  mounted() {
    this.init();
  },
  watch: {
    collapse(val,old) {
      this.$emit('tabsHeight', val)
    }
  },
  methods: {
    async init() {
      let data = {
        planTime: this.form.planTime,
        storeId: this.form.storeId
      };
      let res = await this.$q.preSalePlan.planShopGrade({data});
      
      if(res.success && res.data && res.data.length) {
        this.storeList = res.data
        this.collapseNStore = res.data.slice(0,7)
        this.collapseYStore = res.data.slice(7,res.data.length)
        // 默认显示第一个店铺数据
        let {shopName, storeId} = this.storeList[0];
        this.activeName = shopName;
        this.$emit('change', {storeId, storeName: shopName})
      }else{
        this.storeList = [];
        this.$emit('change', {storeId: 0, storeName: '全平台'})
      }
    },
    handleRadioChange(name) {
      console.log(name);
      this.activeName = name;
      let storeId = this.storeList.filter(v=>v.shopName===name)[0].storeId;
      this.$bus.$emit( 'downloadStore', storeId)
      this.$emit('change', {storeId, storeName: name})
    }
  }
}
</script>

<style lang="stylus" scoped>
  
  .iconfont
    font-size 20px
    position absolute
    top 4px
    right 6px
    &[class*=A]
      color #67C23A
    &[class*=B]
      color #E6A23C
    &[class*=C]
      color #F56C6C

  >>> .el-radio--small.is-bordered
    padding-right 35px
    background #ffffff
  
  >>> .el-radio-group
    width 100%

  >>> .el-radio--small.is-bordered {
    margin-left: 0 !important
    margin-right: 40px
    margin-bottom: 15px
  }
</style>